import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import ResourcesTable from './components/ResourcesTable';
import ResourcesMobile from './components/ResourcesMobile';
import ResourcesProvider from './components/ResourcesProvider';
import ResponsiveView from 'legacy-src/utility/ResponsiveView';

import './index.scss';

/**
 * Draws assignment data for units resources tab
 * */
const AssignmentResources = (props) => {
  const {
    studentId,
    students,
    assignment: {
      id: assignmentId,
      questions: assignmentQuestions,
      students: assignmentStudents,
      isIndividualAssignment,
      scoreDisplay,
    },
    hasFrqQuestions,
    courseOutlineConfig = {},
    learnosityReportsByItemData,
    tagPairsData,
    studentContext,
    reviewModeFlag,
  } = props;

  const {
    curriculumCheckTabLabel,
    subunitLabel,
    widgetTagColumnLabel,
    ppcTagPair,
  } = courseOutlineConfig.data || {};

  /**
   * Default raw columns
   * Provider fills to list other columns and/or add labels
   * */
  /**
   * @note - improvement to support column position in the table
   * remove hardcoded value and add it dynamically
   * */
  let pairs = ppcTagPair ? ppcTagPair.split(',') : [];
  const hasTopic = pairs.includes('Topic');
  const hasOnlyOnePair = pairs.length === 1;

  let colsData = [
    {
      label: hasOnlyOnePair ? curriculumCheckTabLabel : subunitLabel,
      className: `Assignment--resources--subunit ${
        hasOnlyOnePair ? 'has-one-pair' : ''
      }`,
      mobile: {
        contentType: 'text',
      },
    },
    {
      label: widgetTagColumnLabel,
      className: 'Assignment--resources--skills',
      mobile: {
        contentType: 'text',
      },
    },
  ];

  if (pairs.length === 3) {
    /**
     * Get last two columns
     * @no dynamic support until backend sends the list of columns
     * */
    pairs = pairs.slice(1);
  }

  const rawColumns = pairs.map((pair, index) => {
    const { mobile, label, className } = colsData[index];

    return {
      label,
      className,
      value: pair,
      mobile,
    };
  });

  return (
    <div className="Assignment--resources">
      {!isEmpty(courseOutlineConfig.data) && (
        <ResourcesProvider
          tagPairsData={tagPairsData}
          studentContext={
            studentContext || {
              hasContext: !!studentId,
              studentId,
            }
          }
          assignment={{
            id: assignmentId,
            questions: assignmentQuestions,
            students: assignmentStudents,
            isIndividualAssignment,
          }}
          learnosityReportsByItemData={learnosityReportsByItemData}
          ppcTagPairIdentifiers={ppcTagPair}
          rawColumns={rawColumns}
          students={isEmpty(students) ? assignmentStudents : students}
          hasFrqQuestions={hasFrqQuestions}
          key={assignmentId}
          hasUniqueItems={hasOnlyOnePair}
        >
          <ResponsiveView screens={['desktop']}>
            <ResourcesTable
              key={`table-${assignmentId}`}
              scoreDisplay={scoreDisplay}
              reviewModeFlag={reviewModeFlag}
            />
            <Fragment>
              <div className="na-help-text">
                na = not applicable as no questions measured this{' '}
                {hasTopic ? 'topic and ' : ''}skill on this assessment
              </div>
            </Fragment>
          </ResponsiveView>
          <ResponsiveView screens={['mobile']}>
            <ResourcesMobile key={`table-${assignmentId}`} />
          </ResponsiveView>
        </ResourcesProvider>
      )}
    </div>
  );
};

AssignmentResources.displayName = 'AssignmentResources';

AssignmentResources.propTypes = {
  /**
   * Course outline configuration object
   * */
  courseOutlineConfig: PropTypes.object,
  /**
   * Assignment has frq questions bool
   * */
  hasFrqQuestions: PropTypes.bool,
};

AssignmentResources.defaultProps = {
  courseOutlineConfig: {},
  hasFrqQuestions: false,
  students: [],
};

const mapStateToProps = ({ featureFlag }) => ({
  reviewModeFlag: featureFlag.review_mode,
});

export default connect(mapStateToProps)(AssignmentResources);
